"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var checkboxStyles = makeStyles_1.default(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        root: {
            '&:hover': {
                backgroundColor: 'transparent',
            },
            width: '40px',
            height: '40px',
        },
        labelRoot: {
            padding: '10px',
        },
        label: {
            alignSelf: 'center',
            '& a': {
                color: palette.primary.main,
                textDecoration: 'none',
            },
        },
        formControlContainer: {
            alignItems: 'center',
            display: 'inline-flex',
            padding: '10px 10px 10px 0',
            marginRight: '15px',
        },
        disclaimer: {
            '& span': {
                fontWeight: 'bold',
            },
            '& a': {
                fontWeight: 'bold',
            },
        },
        note: {
            fontFamily: typography.fontFamily,
        },
        marketingInformationDisclaimer: {},
        container: {},
        modalTitle: {
            cursor: 'pointer',
            paddingLeft: '40px',
        },
        clickable: {
            color: palette.primary.main,
        },
    });
}, { name: 'GqlCheckout_Checkbox' });
exports.default = checkboxStyles;
